import { Button } from 'primereact/button';
import { ConfirmPopup, confirmPopup } from 'primereact/confirmpopup';
import { IsNullOrEmpty } from "../../../services/CustomService";
import {
    useLoaderData,
    Form,
    useSubmit
} from "react-router-dom";
import { getService, getServicePaymentFlow, formatCommission } from "../../../data/loca/services";
export async function loader({ params }) {
    const s = await getService(params.serviceId);
    let serv = s.value;
    return { serv };
}
export default function Service() {
    const { serv } = useLoaderData();
    const submit = useSubmit();
    const accept = () => {
        submit(null, { method: "post", action: "delete" })
    };

    const reject = () => {
    };

    const paymentFlow = getServicePaymentFlow(serv?.paymentFlow);

    const deleteService = (event) => {
        confirmPopup({
            target: event.currentTarget,
            message: 'Êtes-vous sûr de vouloir supprimer ce service ?',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Oui',
            rejectLabel: 'Non',
            accept,
            reject
        });
    };

    return (
        <div>
            <div id="thumbnail">

                {(serv) ? (
                    <>
                        {(!IsNullOrEmpty(serv.base64Picture)) ? (
                            <img className="servicePicture" height="192" key={serv.publicId} alt={serv.name} src={serv.base64Picture || null} />

                        ) : (
                            <div className="no-picture no-picture-large"></div>
                        )}

                        <div>
                            <h1>
                                {serv.name ? (
                                    <>
                                        {serv.name}
                                    </>
                                ) : (
                                    <i>Inconnu</i>
                                )}{" "}
                            </h1>

                            <div>
                                {serv.canEdit && (
                                    <Form action="modification">
                                        <Button type="submit" size="small">Modifier le service</Button>
                                    </Form>
                                )}


                                {!serv.isPublic && (
                                    <>
                                        <ConfirmPopup />
                                        <Button onClick={deleteService} icon="pi pi-trash" label="" size="small" className="p-button-danger"></Button>
                                    </>
                                )}
                            </div>

                            <div className="platform-flow-summary">
                                <h2>{paymentFlow.label}</h2>
                                <p>{paymentFlow.description}</p>
                                <span className="platform-flow-steps">
                                    {paymentFlow.steps.map((step) => (
                                        <span key={step}><i className="pi pi-check-circle"></i>{step}</span>
                                    ))}
                                </span>
                                <p><b>Commission :</b> {formatCommission(serv.commissionPercent)}</p>
                                <p><b>Article 3bis du contrat :</b> {(serv.contractTerms || "").trim() ? "" : "aucun"}</p>
                                {(serv.contractTerms || "").trim() && (
                                    <pre className="platform-contract-terms">{serv.contractTerms}</pre>
                                )}
                            </div>
                        </div>
                    </> 

                
                ) : (
                    <div id="error-page">
                        <h1>Erreur</h1>
                        <p>Le service est introuvable ou vous n'y avez pas accès !</p>
                    </div>
                       
                )}
                
                
            </div>
            <div id="mainContent">
               
                
            </div>
    </div>
    );
}
